document.addEventListener('DOMContentLoaded', function () {

  let currencyConfig =  {
    money_format: "{{amount_with_comma_separator}} kr",
    money_in_emails_format: "",
    money_with_currency_format: "{{amount_with_comma_separator}} kr",
    money_with_currency_in_emails_format: "",
    thousandsSeperator: "."
  };
    
    if (document.getElementById('shop_currency_format')) {
        const shopCurrencyFormat = document.getElementById('shop_currency_format').textContent;
        currencyConfig = JSON.parse(shopCurrencyFormat);

        console.log('currencyConfig', currencyConfig)
    }
    

    // Money formatting function
    function formatMoney(amount, format = currencyConfig.money_with_currency_format) {
        // console.log('format', format)
        // Helper to format numbers with the given separators
        function formatNumber(amount, decimals, thousandSeparator, decimalSeparator) {
            const options = {
                minimumFractionDigits: decimals ? 2 : 0,
                maximumFractionDigits: decimals ? 2 : 0,
                useGrouping: true
            };

            return (amount / 100).toLocaleString('da', options)
                .replace('.', thousandSeparator) 
                .replace(',', decimalSeparator)
        }


        // Prepare the number formats based on the provided format
        switch (true) {
            case format.includes('{{amount_no_decimals_with_comma_separator}}'):
                return format.replace('{{amount_no_decimals_with_comma_separator}}', formatNumber(amount, false, '.', ','));

            case format.includes('{{amount_no_decimals}}'):
                return format.replace('{{amount_no_decimals}}', formatNumber(amount, false, ',', '.'));

            case format.includes('{{amount_with_comma_separator}}'):
                return format.replace('{{amount_with_comma_separator}}', formatNumber(amount, true, '.', ','));

            case format.includes('{{amount_no_decimals_with_apostrophe_separator}}'):
                return format.replace('{{amount_no_decimals_with_apostrophe_separator}}', formatNumber(amount, false, "'", '.'));

            case format.includes('{{amount_with_space_separator}}'):
                return format.replace('{{amount_with_space_separator}}', formatNumber(amount, true, ' ', ','));

            case format.includes('{{amount_with_apostrophe_separator}}'):
                return format.replace('{{amount_with_apostrophe_separator}}', formatNumber(amount, true, "'", '.'));

            case format.includes('{{amount_no_decimals_with_space_separator}}'):
                return format.replace('{{amount_no_decimals_with_space_separator}}', formatNumber(amount, false, ' ', '.'));

            case format.includes('{{amount_with_period_and_space_separator}}'):
                return format.replace('{{amount_with_period_and_space_separator}}', formatNumber(amount, true, ' ', '.'));

            default:
                return format.replace('{{amount}}', formatNumber(amount, true, ',', '.'));
        }
    }
    
    function calculateTotal() {
        let totalPrices = 0;
        let totalPricesFinal = 0;
        let bundleDiscount = 0;

        // Select all products that are marked as infected
        const selectedProducts = document.querySelectorAll('.product-bundle__rules-item.infected');
        let totalQuantity = 0;
        selectedProducts.forEach(selectedProduct => {
            const jsonElement = selectedProduct.querySelector('[type="application/json"]');
            if (selectedProduct.querySelector(`[name^="bundle_quantities"]`)) {
                _tqty = selectedProduct.querySelector(`[name^="bundle_quantities"]`).value;
                totalQuantity += parseInt(_tqty)
            }
            // If the JSON element exists, process it
            if (jsonElement) {
                const context = jsonElement.textContent;
    
                try {
                    const parseContext = JSON.parse(context);
    
                    // Parse and accumulate the prices
                    const beforePrice = parseFloat(parseContext?.beforePrice ?? 0);
                    const price = parseFloat(parseContext?.price ?? 0);
                    
                    //console.log('beforePrice', beforePrice)
                    totalPrices += price;
                    //totalPrices += beforePrice;
    
                } catch (error) {
                    console.error('Error parsing JSON', error);
                }
            } else {
                console.warn('No JSON element found in this selected product');
            }
        });

        // Now get the bundle rules and apply the discount based on the quantity
        const bundleWrapper = document.querySelector('.bundle-wrapper > [type="application/json"]');
        // console.log('bundleWrapper',bundleWrapper)
        let min_qty = Infinity;
        if (bundleWrapper) {
            const bundleContext = JSON.parse(bundleWrapper.textContent);
            const rules = bundleContext?.rules ?? [];
            const totalQty = totalQuantity; // Ensure totalQuantity is defined and correct
            //console.log('bundleContext', bundleContext);
            //console.log('rules', rules);
            //console.log('totalQty', totalQty);
            
            rules.forEach(rule => {
                const rule_qty = parseFloat(rule.qty); // Access qty directly
        
                if (!isNaN(rule_qty) && rule_qty < min_qty) {
                    min_qty = rule_qty; // Find the minimum quantity
                }
        
                if (totalQty >= rule_qty) {
                    bundleDiscount = parseFloat(rule.discount);
                }
            });

            // Calculate total final price after applying the discount
            totalPricesFinal = totalPrices - (totalPrices * (bundleDiscount / 100));
        }

        selectedProducts.forEach(selectedProduct => {
            const jsonElement = selectedProduct.querySelector('[type="application/json"]');
            if (jsonElement) {
                const context = jsonElement.textContent;
    
                try {
                    const parseContext = JSON.parse(context);
    
                    // Parse and accumulate the prices
                    const beforePrice = parseFloat(parseContext?.beforePrice ?? 0);
                    const price = parseFloat(parseContext?.price ?? 0);
                    
                    if(bundleDiscount){
                      const newPrice = price - ((bundleDiscount * price) / 100);
                      console.log('newPrice', newPrice)
                      selectedProduct.querySelector('.no-price-bundle').innerHTML = formatMoney(newPrice)
                    }
    
                } catch (error) {
                    console.error('Error parsing JSON', error);
                }
            }
        });
    
        // Update the HTML with the calculated totals
        const totalPricesFormated = formatMoney(totalPrices);
        const totalPricesFinalFormated = formatMoney(totalPricesFinal);

        //console.log('totalPricesFormated', totalPricesFormated);
        //console.log('min_qty', min_qty);
        //console.log('totalQuantity', totalQuantity);
        //console.log('selectedProducts', selectedProducts.length);

        document.querySelector('[data-total-before]').innerHTML = totalPricesFormated;
        document.querySelector('[data-total-final]').innerHTML = totalPricesFinalFormated ;
        document.querySelector('[data-discount]').innerHTML = `Du sparer ${bundleDiscount}%`;

        if (selectedProducts.length > 1 && totalQuantity >= min_qty ) {
            document.querySelector('.product-bundle__totals').classList.remove('visually-hidden')
        }
        else {
            document.querySelector('.product-bundle__totals').classList.add('visually-hidden')
        }

        const _selectedProducts = document.querySelectorAll('.product-bundle__rules-item');

        if (selectedProducts.length == _selectedProducts.length ) {
            document.querySelector('.extra--wine_buttons').classList.remove('visually-hidden')
        }
        else {
            document.querySelector('.extra--wine_buttons').classList.add('visually-hidden')
        }

        
    }

    const reinit_totals = () => {
        calculateTotal();
    }
    
    
    function init_bundle_items() {
        const bundleDeleteActions = document.querySelectorAll('[data-delete-bundle-item]');

        bundleDeleteActions.forEach(bundleDeleteAction => {
            bundleDeleteAction.addEventListener('click', function (event) {
                event.preventDefault();
                let item = this.closest('.product-bundle');
                if(!item) item = this.closest('.product-bundle___item');
                if (item && this.closest('[data-item]')) {
                    //console.log(this.closest('[data-item]'))
                    if (this.closest('[data-item]').getAttribute('data-extra-vine') == "true") {
                        //console.log('remove')
                        this.closest('[data-item]').remove();
                    }
                    else {
                        this.closest('[data-item]').classList.remove('target_selection');
                        this.closest('[data-item]').classList.remove('infected');

                        const wine_button = document.querySelector('.wine_button').innerHTML;
                        this.closest('[data-item]').innerHTML = wine_button;
                        //this.closest('[data-item]').innerHTML = '<button type="button" class="bg-white" data-panel-target="panel--bundle">Vælg vin</button>';
                        item.remove();
                    }
                    
                    // init_bundle();
                    panel_init(false);
                    reinit_totals();
                }
            });
        });

        calculateTotal();
    }   

    function init_bundle() {
        const bundleOptions = document.querySelector('[data-bundle-options]');
        const bundleActions = document.querySelectorAll('[data-bundle-action]');
        const addBundleToAcarts = document.querySelectorAll('[data-add-bundle-to-cart]');

        if (addBundleToAcarts) {
            addBundleToAcarts.forEach(addBundleToAcart => {
                addBundleToAcart.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.target.classList.add('sending')
                    const selectedProducts = document.querySelectorAll('.product-bundle__rules-item');
                    const items = [];
                    selectedProducts.forEach(selectedProduct => {
                        if (selectedProduct.querySelector(`[name^="bundle_quantities"]`)) {
                            items.push({
                                'id': selectedProduct.querySelector(`[name^="bundle_quantities"]`).getAttribute('data-variant-id'),
                                'quantity': selectedProduct.querySelector(`[name^="bundle_quantities"]`).value
                            })
                        }
                    });

                    if (items) {
                        const formData = {
                            items
                        }
                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formData)
                          }).then(response => {
                            return response.json();
                          }).catch((error) => {
                              console.error('Error:', error);
                              event.target.classList.remove('sending')
                          }).finally(() => {
                            event.target.classList.remove('sending')
                        })
                    }
                });
            });
        }
        
        if (bundleOptions) {
            bundleOptions.addEventListener('click', function(event) {
                event.preventDefault(); 
    
                const productBundles = event.currentTarget.closest('.product-bundles');
                if (productBundles) {
                    const flexElement = productBundles.querySelector('.flex');
                    const flexCollapseElement = productBundles.querySelector('.flex-collapse');
                    const pdpPrices = document.querySelector('.bundle-wrapper .pdp-prices');
    
                    if (flexElement) {
                        flexElement.classList.add('collapse');
                    }
    
                    if (flexCollapseElement) {
                        flexCollapseElement.classList.add('active');
                    }

                    if (pdpPrices) {
                        pdpPrices.classList.add('visually-hidden');
                    }
                }
            });
        }
    
        if (bundleActions) {
            bundleActions.forEach(bundleAction => {
                bundleAction.addEventListener('click', function(event) {
                    event.preventDefault(); 
                    //console.log('action', 'write')
                    const productBundle = event.currentTarget.closest('.product-bundle-item');
                    if (productBundle) {
                        let previewTarget = document.querySelector('.target_selection');
                        const quantity = productBundle.querySelector('[name="quantities"]').value;
                       
                        if (quantity == 1) {
                            if (!previewTarget) {
                                // Create a new div element
                                const newDiv = document.createElement('div');
                                
                                // Set the class and data attributes for the new div
                                newDiv.className = 'product-bundle__rules-item target_selection';
                                newDiv.setAttribute('data-item', ''); // Set this dynamically if needed
                                newDiv.setAttribute('data-extra-vine', 'true');
                            
                                // Create a new button element
                                const newButton = document.createElement('button');
                                
                                // Set the button attributes
                                newButton.type = 'button';
                                newButton.className = 'bg-white';
                                newButton.setAttribute('data-panel-target', 'panel--bundle');
                                newButton.textContent = 'Vælg vin';
                            
                                // Append the button to the div
                                newDiv.appendChild(newButton);
                            
                                // Find the parent element to append the new div
                                const parentElement = document.querySelector('.product-bundle__rules-items');
                                
                                // Check if parentElement exists
                                if (parentElement) {
                                    // Append the new div to the parent element
                                    parentElement.appendChild(newDiv);
                                } else {
                                    console.warn('Parent element .product-bundle__rules-items not found');
                                }
    
                                previewTarget = document.querySelector('.target_selection');
                                
                            }

                            if (previewTarget.classList.contains("infected")) {
                                // Find the next sibling that doesn't contain the 'infected' class
                                let nextItem = previewTarget.nextElementSibling;
                            
                                while (nextItem && nextItem.classList.contains("infected")) {
                                    nextItem = nextItem.nextElementSibling; // Keep moving to the next sibling
                                }
                            
                                // If a valid 'nextItem' is found, add the 'target_selection' class
                                if (nextItem) {
                                    nextItem.classList.add('target_selection');
                                    // Only remove the 'target_selection' class from the current element if a valid nextItem was found
                                    previewTarget.classList.remove('target_selection');
                                }
                            }
                            

                            previewTarget = document.querySelector('.target_selection');

                            // Find the preview element and copy it to previewTarget
                            const previewOption = productBundle.querySelector('.product-bundle__preview');
                            if (previewOption && previewTarget) {
                                // Copy the HTML content first
                                previewTarget.innerHTML = previewOption.innerHTML;
                                previewTarget.classList.add('infected');
                    
                                // After the content is copied, find and update the bundle_quantities input inside previewTarget
                                const bundleQuantitiesInput = previewTarget.querySelector(`[name^="bundle_quantities"]`);
                                if (bundleQuantitiesInput) {
                                    //bundleQuantitiesInput.value = quantity;
                                }
                            } 
                        }
                        else {

                            const existingNonTargetSelectionCount = document.querySelectorAll('.product-bundle__rules-item:not(.target_selection):not(.infected)').length;
                            const targetSelectionCount = document.querySelectorAll('.product-bundle__rules-item.target_selection:not(.infected)').length;
                            const slots = existingNonTargetSelectionCount + targetSelectionCount;

                            //console.log('slots', slots)

                            if (slots < quantity) {
                                const minus = quantity - slots;
                                for (let index = 0; index < minus; index++) {
                                    // Create a new div element
                                    const newDiv = document.createElement('div');
                                    
                                    // Set the class and data attributes for the new div
                                    newDiv.className = 'product-bundle__rules-item target_selection';
                                    newDiv.setAttribute('data-item', ''); // Set this dynamically if needed
                                    newDiv.setAttribute('data-extra-vine', 'true');
                                
                                    // Create a new button element
                                    const newButton = document.createElement('button');
                                    
                                    // Set the button attributes
                                    newButton.type = 'button';
                                    newButton.className = 'bg-white';
                                    newButton.setAttribute('data-panel-target', 'panel--bundle');
                                    newButton.textContent = 'Vælg vin';
                                
                                    // Append the button to the div
                                    newDiv.appendChild(newButton);
                                
                                    // Find the parent element to append the new div
                                    const parentElement = document.querySelector('.product-bundle__rules-items');
                                    
                                    // Check if parentElement exists
                                    if (parentElement) {
                                        // Append the new div to the parent element
                                        parentElement.appendChild(newDiv);
                                    } 
                                    
                                }
                            }

                            let number = 1;
                            document.querySelectorAll('.product-bundle__rules-item:not(.target_selection):not(.infected)').forEach(item => {
                                if (number < quantity) item.classList.add('target_selection')
                                number++;
                            });  
                            
                            // Update all target_selection elements with preview information
                            const previewOption = productBundle.querySelector('.product-bundle__preview');
                            let previewTargets = document.querySelectorAll('.target_selection');

                            previewTargets.forEach(target => {
                                
                                if (target.classList.contains("infected")) {
                                    // Check if there's only one element with the class 'target_selection infected'
                                    let nextItem = target.nextElementSibling;

                                    while (nextItem && nextItem.classList.contains("infected")) {
                                        nextItem = nextItem.nextElementSibling; // Keep moving to the next sibling
                                    }

                                    // If a valid 'nextItem' is found, add the 'target_selection' class
                                    if (nextItem) {
                                        nextItem.classList.add('target_selection');
                                        // Only remove the 'target_selection' class from the current element if a valid nextItem was found
                                        target.classList.remove('target_selection');
                                    }
                                }
                            });

                            previewTargets = document.querySelectorAll('.target_selection');
                            
                            previewTargets.forEach(previewTarget => {
                                if (previewOption) {
                                    previewTarget.innerHTML = previewOption.innerHTML;
                                    previewTarget.classList.add('infected');

                                    const bundleQuantitiesInput = previewTarget.querySelector(`[name^="bundle_quantities"]`);
                                    if (bundleQuantitiesInput) {
                                        //bundleQuantitiesInput.value = quantity;
                                    } else {
                                        console.warn('bundle_quantities input not found in previewTarget');
                                    }
                                } else {
                                    console.warn('Preview option not found');
                                }
                            });
                            
                        }

                        // Handle the panel closing and animation
                        const panel = this.closest('.panel');
                        if (panel) {
                            panel.classList.remove('animate');
                            setTimeout(function(){
                                panel.classList.remove('open');
                                document.body.classList.remove('overflow-hidden');
                                panel_init();
                                init_bundle_items();
                            }, 300);
                        }
                    }
                });
                
            });
        }

        init_bundle_items();
        
    }

    if (document.getElementById('shop_currency_format')) {
        init_bundle();
    }
    
});


class StickySection extends HTMLElement {
    constructor() {
        super();
        this.stickySection = this.querySelector('.sticky--purchase');
        this.purchaseForm = document.querySelector('.purchase-form'); // Select the purchase form outside
        this.desktopQuery = window.matchMedia('(min-width: 768px)');
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.isInputFocused = false; 

        this.setupScrollListenerDesktop();
        this.setupScrollListenerMobile();

        // Prevent zoom on input focus for mobile
        document.addEventListener('touchstart', (event) => {
            if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
                document.body.style.zoom = "1"; // Prevent zoom
                //console.log('touchstart')
            }
        });

        // Event listeners to manage input focus
        document.addEventListener('focusin', (event) => {
            if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
                this.isInputFocused = true;
                this.setSticky();
            }
        });

        document.addEventListener('focusout', () => {
            this.isInputFocused = false;
        });
    }

    setupScrollListenerDesktop() {
        if (this.desktopQuery.matches) {
            window.addEventListener('scroll', this.scrollHandler.bind(this));
        }
    }

    setupScrollListenerMobile() {
        if (this.mobileQuery.matches) {
            this.observer = new IntersectionObserver(this.observerCallback.bind(this), this.observerOptions);
            this.observer.observe(this.purchaseForm);
        }
    }

    observerCallback(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting || this.isInputFocused) {
                this.removeSticky();
            } else {
                this.setSticky();
            }
        });
    }

    get observerOptions() {
        return {
            root: null, // Use the viewport as the container
            rootMargin: '0px', // Margin around the root
            threshold: 0.9, // Trigger callback when 10% of the element is visible
        };
    }

    scrollHandler() {
        // Check if the mainForm is out of the viewport
        //const offsetTop = this.purchaseForm.offsetTop;
        //const offsetHeight = this.purchaseForm.offsetHeight;
        if (this.isInputFocused) {
            this.setSticky();
        } else if (window.scrollY > this.purchaseForm.offsetTop + this.purchaseForm.offsetHeight) {
            this.setSticky();
        } else {
            this.removeSticky();
        }
    }

    setSticky() {
        this.stickySection.classList.add('animate-move-down');
        this.stickySection.classList.remove('opacity-0');
        this.stickySection.classList.add('opacity-100'); // Ensure visibility
    }

    removeSticky() {
        this.stickySection.classList.remove('animate-move-down');
        this.stickySection.classList.add('opacity-0');
        this.stickySection.classList.remove('opacity-100'); // Ensure it's hidden
    }
}

// Define the custom element
customElements.define('sticky-section', StickySection);
